/* eslint-disable @typescript-eslint/no-explicit-any */
import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import 'firebase/compat/firestore'
import { getFunctions, httpsCallable } from 'firebase/functions'

/**
 * Create collection snapshot instance.
 * @param collectionName String. Collection name
 */
export const getCollectionReference = (collectionName: string) => {
  return firebase.firestore().collection(collectionName)
}

/**
 * Authentication for user
 * @param email String,
 * @param password String.
 */
export const authenticate = async (email: string, password: string) => {
  return await firebase.auth().signInWithEmailAndPassword(email, password)
}

/**
 * Sign out authenticated user
 */
export const authSignOut = async () => {
  return await firebase.auth().signOut()
}

export const authAddAdmin = async (email: string): Promise<any> => {
  const a = httpsCallable(getFunctions(), 'registerAdmin')
  await a(email).then((result: any) => {
    console.log('result: ', result)
    console.log(result?.data)
  })
}

export const authRemoveAdmin = async (email: string): Promise<any> => {
  const a = httpsCallable(getFunctions(), 'removeAdmin')
  await a(email).then((result: any) => {
    console.log('result: ', result)
    console.log(result?.data)
  })
}

export const authViewAdmin = async (): Promise<any> => {
  const a = httpsCallable(getFunctions(), 'viewAdmin')
  await a().then((result: any) => {
    console.log('result: ', result)
    console.log(result)
  })
}

export const addNewNFTProject = async (slug: string, chain: string): Promise<any> => {
  const a = httpsCallable(getFunctions(), 'addNewCollection')
  const query = { slug: slug, chain: chain }
  // const data = { query }
  await a({ query }).then((result: any) => {
    console.log('result: ', result)
    console.log(result)
  })
}

/**
 * This method will return current timestamp
 * @returns Current timestamp
 */
export const currentTimeStamp = async () => {
  return await firebase.firestore.Timestamp.now();
};

/**
 * This method will return timestamp
 * @returns timestamp
 */

 export const convertTimeStamp = async (date: string) => {
  return await firebase.firestore.Timestamp.fromDate(new Date(date));
};
